import { defineMessages } from 'react-intl';

export const actionMessages = defineMessages({
    barriers: {
        id: 'barriers',
        defaultMessage: 'Barriers',
    },
    barrierActions: {
        id: 'barrier-actions',
        defaultMessage: 'Barrier actions',
    },
    emergencyActions: {
        id: 'emergency-actions',
        defaultMessage: 'Emergency actions',
    },
    performEmergencyAction: {
        id: 'perform-emergency-action',
        defaultMessage: 'Perform an emergency action',
    },
    raiseBarrier: {
        id: 'raise-barrier',
        defaultMessage: 'Raise barrier',
    },
    chooseBarrierToRaise: {
        id: 'choose-barrier-to-raise',
        defaultMessage: 'Choose a barrier to raise',
    },
    emergencyRaiseBarrier: {
        id: 'emergency-raise-barrier',
        defaultMessage: 'Emergency raise barrier',
    },
    raiseBarrierImmediately: {
        id: 'raise-barrier-immediately',
        defaultMessage: 'Raise a barrier immediately',
    },
    emergencyLowerBarrier: {
        id: 'emergency-lower-barrier',
        defaultMessage: 'Emergency lower barrier',
    },
    allActions: {
        id: 'all-actions',
        defaultMessage: 'All actions',
    },
    quickActions: {
        id: 'quick-actions',
        defaultMessage: 'Quick Actions',
    },
    customiseQuickActions: {
        id: 'customise-quick-actions',
        defaultMessage: 'Customise quick actions',
    },
    barrierActionReason: {
        id: 'reason',
        defaultMessage: 'Reason',
    },
    barrierActionLocation: {
        id: 'location',
        defaultMessage: 'Location',
    },
    lowerBarrierImmediately: {
        id: 'lower-barrier-immediately',
        defaultMessage: 'Lower a barrier immediately',
    },
    barrierActionSuccess: {
        id: 'barrier-action-success',
        defaultMessage: 'Barrier action successfully completed',
    },
    barrierActionSuccessDetails: {
        id: 'barrier-action-success-details',
        defaultMessage: 'Barrier action {action} at point {point} successfully completed.',
    },
    pointIdPlaceholder: {
        id: 'point-id-placeholder',
        defaultMessage: 'Choose a location',
    },
    reasonPlaceholder: {
        id: 'reason-placeholder',
        defaultMessage: 'Choose a reason',
    },
    actions: {
        id: 'actions',
        defaultMessage: 'Actions',
    },
});
